/* eslint-disable camelcase, no-magic-numbers */
/*global OFFICE_INFO, google, L */
void (function doMaps() {
	'use strict';

	const {
		latitude,
		longitude,
		office_name,
		street_1,
		street_2,
		city,
		province,
		postal_code,
		google_place_id,
		mapbox_api_key,
	} = OFFICE_INFO;
	const mapBox = {
		initDynamic: (mapContainer) => {
			if (typeof L === 'undefined') return;
			const defaultZoom = 17;
			const map = L.map(mapContainer, {
				dragging: !L.Browser.mobile,
				tap: !L.Browser.mobile,
			}).setView([latitude, longitude], defaultZoom);
			const addressFull = `${street_1}${street_2 ? `, ${street_2}` : ''}
				${city}, ${province} ${postal_code}`;
			const searchURI = encodeURI(
				`https://www.google.com/maps/search/?api=1&query=${office_name} ${addressFull}&query_place_id=${google_place_id}`,
			);

			const componentToHex = (c) => c.toString(16).padStart(2, '0');
			const getBrandColor = () => {
				const bc = getComputedStyle(document.documentElement)
					.getPropertyValue('--color-primary')
					.trim();
				if (bc.startsWith('#')) return bc.split('#')[1];
				if (bc.startsWith('rgb(')) {
					const rgb = bc.replace(/[^\d,]/g, '').split(',');
					return rgb.map((c) => `${componentToHex(c)}`).join('');
				}
				return '0000ff';
			};
			const pinImage = {
				iconUrl: `https://res.cloudinary.com/heartland-dental/image/upload/c_scale,e_colorize:100,co_rgb:${getBrandColor()},h_50/v1587694139/_common/assets/map-pin.png`,
				iconSize: [50, 50],
				iconAnchor: [25, 50],
				popupAnchor: [0, -30],
				className: 'dot',
			};
			// brandColor - expects hex value.
			const mapMode =
				getComputedStyle(document.documentElement)
					.getPropertyValue('--theme-colormode')
					.trim() === 'dark'
					? 'dark-v10'
					: 'light-v10';
			L.tileLayer(
				`https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=${mapbox_api_key}`,
				{
					maxZoom: 18,
					id: `mapbox/${mapMode}`, // dark-v10 || light-v10
					accessToken: mapbox_api_key,
				},
			).addTo(map);
			L.marker([latitude, longitude])
				.bindPopup(
					`<div class="office-name"><strong>${office_name}</strong></div>
					<div class="address">
						<div class="line1">${street_1}</div>
						${street_2 ? `<div class="line2"><em>${street_2}</em></div>` : ''}
						<div class="locale"><span class="city">${city}</span>, <span class="state">${province}</span> <span class="zip">${postal_code}</span></div>
					</div>
					<div class="directions"><a href="${searchURI}">Get Directions</a></div>`,
				)
				.setIcon(L.icon(pinImage))
				.addTo(map)
				.fire('click');
		},
	};

	const googleMaps = {
		getStarRatingHtml: (place) => {
			if (!place.rating) return null;
			const rating = (
				place.rating % 1 === 0
					? `${place.rating}.0`
					: Math.round(place.rating * 10) / 10
			).toString();
			const googleAttributionImg = document
				.querySelector('.welcome')
				.classList.contains('welcome-congaree')
				? 'https://res.cloudinary.com/heartland-dental/image/upload/v1556576649/_common/integration/powered_by_google_on_non_white_hdpi.png'
				: 'https://res.cloudinary.com/heartland-dental/image/upload/v1556576649/_common/integration/powered_by_google_on_white_hdpi.png';
			return `<div class="ratings-display">
				<span class="rating-value">${rating}</span>
				<span class="stars" data-rating="${rating}" title="${rating} out of 5 stars"><span style="width: ${
					(rating / 5) * 100
				}%;"></span></span>
				<span class="attribution"><img src="${googleAttributionImg}" alt="Powered by Google" width="144" style="width:144px" /></span>
			</div>`;
		},
		getRatingData: (widget) => {
			if (!google_place_id) return;
			const service = new google.maps.places.PlacesService(
				document.createElement('div'),
			);
			service.getDetails(
				{
					placeId: google_place_id,
					fields: ['rating'],
				},
				(place, getDetailsStatus) => {
					if (
						getDetailsStatus !==
						google.maps.places.PlacesServiceStatus.OK
					)
						return;

					if (!place.rating) return;
					widget.innerHTML = googleMaps.getStarRatingHtml(
						place,
						widget,
					);
				},
			);
		},
	};
	document.addEventListener('DOMContentLoaded', () => {
		const mapList = document.querySelectorAll('.map-container .mapbox');
		for (const map of mapList) mapBox.initDynamic(map);

		const ratingsWidgets = document.querySelectorAll(
			'.star-ratings-google',
		);
		for (const widget of ratingsWidgets) googleMaps.getRatingData(widget);
	});
})();
